import { Checkbox, FormControlLabel } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";

export default function CheckBox({
  label = "",
  handleClick = () => {},
  checked = false,
  hideCheckbox,
  readOnly = false,
}) {
  const handleOnCheck = (event) => {
    if (readOnly) {
      return;
    }

    handleClick?.(event.target.checked);
  };

  return (
    <FormControlLabel
      sx={{
        opacity: readOnly ? 0.75 : 1,
        "& .MuiFormControlLabel-label": {
          color: readOnly ? HNSColors.neutrals[500] : "inherit",
        },
      }}
      name={`${label}_checkbox`}
      control={
        <Checkbox
          sx={
            readOnly
              ? {
                  color: HNSColors.neutrals[500],
                  borderRadius: "0.57px",
                  borderWidth: "0.5px",
                  visibility: hideCheckbox ? "hidden" : "visible",
                  "&.Mui-checked": {
                    color: HNSColors.neutrals[500],
                  },
                  "&.Mui-disabled": {
                    color: HNSColors.neutrals[500],
                  },
                }
              : {
                  color: HNSColors.primary[800],
                  borderRadius: "0.57px",
                  borderWidth: "0.5px",
                  visibility: hideCheckbox ? "hidden" : "visible",
                }
          }
          checked={checked}
          disableRipple={readOnly}
          disabled={readOnly}
          onChange={(event) => handleOnCheck(event)}
          inputProps={{ readOnly }}
        />
      }
      label={label}
    />
  );
}
